import {NgModule} from '@angular/core';
import {SharedModule} from '../shared/shared.module';
import {ReportService} from './report.service';
import {ReportDatatableComponent} from './report-datatable.component';
import {ReportOverviewComponent} from './report-overview.component';
import {ReportFormComponent} from './report-form.component';

@NgModule({
  declarations: [
    ReportDatatableComponent,
    ReportOverviewComponent,
    ReportFormComponent
  ],
  exports: [
    ReportDatatableComponent,
    ReportOverviewComponent,
    ReportFormComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    ReportService
  ]
})
export class ReportModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/report/report.module.ts